import {
  get,
  post,
  put,
  destroy
} from 'app/services/ApiService';

import {
  SEARCH_ACCESS_CODE_PAGES_URL,
  ACCESS_CODE_PAGES_URL,
  ACCESS_CODE_PAGE_URL,
  ACCESS_CODE_PAGE_LOGO_UPLOAD_URL,
  ACCESS_CODE_PAGE_BACKGROUND_UPLOAD_URL,
  ACCESS_CODE_PAGE_VIDEO_UPLOAD_URL,
  ACCESS_CODE_PAGE_FAVICON_UPLOAD_URL,
  ACCESS_CODE_PAGE_METADATA_URL
} from 'app/utils/Constants';

import {
  TEXT,
  EQUALS
} from 'app/hooks/useFilter';

export const getAccessCodePage = async id => {
  let params = {
    page: 1,
    per_page: 1,
    filter_model: {
      id: [{
        filterClass: TEXT,
        filterType: EQUALS,
        value: id.toString()
      }]
    },
    sort_model: []
  }

  let resp = await getAccessCodePages(params);
  return resp.records[0];
}

export const getAccessCodePages = async params => {
  return await post(SEARCH_ACCESS_CODE_PAGES_URL(), params);
}

export const createAccessCodePage = async params => {
  return await post(ACCESS_CODE_PAGES_URL(), params);
}

export const updateAccessCodePage = async (id, params) => {
  return await put(ACCESS_CODE_PAGE_URL(id), params);
}

export const destroyAccessCodePage = async id => {
  return await destroy(ACCESS_CODE_PAGE_URL(id));
}

export const getAccessCodePageLogoUploadUrl = async id => {
  return await get(ACCESS_CODE_PAGE_LOGO_UPLOAD_URL(id));
}

export const getAccessCodePageBackgroundUploadUrl = async id => {
  return await get(ACCESS_CODE_PAGE_BACKGROUND_UPLOAD_URL(id));
}

export const getAccessCodePageVideoUploadUrl = async id => {
  return await get(ACCESS_CODE_PAGE_VIDEO_UPLOAD_URL(id));
}

export const getAccessCodePageFaviconUploadUrl = async id => {
  return await get(ACCESS_CODE_PAGE_FAVICON_UPLOAD_URL(id));
}

export const getAccessCodePageMetaData = async pageId => {
  return await get(ACCESS_CODE_PAGE_METADATA_URL(pageId));
}